export default function expect(val) {
    return {
        isString() {
            return typeof val === 'string';
        },
        isNumber() {
            return typeof val === 'number';
        },
        isBoolean() {
            return typeof val === 'boolean';
        },
        isArray() {
            return Array.isArray(val);
        },
        isNull() {
            return val === null;
        },
        isUndefined() {
            return typeof val === 'undefined';
        },
        isSymbol() {
            return typeof val === 'symbol';
        },
        // 是基础类型
        isBasic() {
            return this.isString()
                || this.isNumber()
                || this.isBoolean()
                || this.isNullOrUndefined()
                || this.isSymbol();
        },
        isFunction() {
            return typeof val === 'function';
        },
        isObj() {
            return typeof val === 'object' && !this.isArray() && !this.isNull();
        },
        isEmptyObj() {
            return this.isObj() && !Object.keys(val).length;
        },
        isNullOrUndefined() {
            return this.isNull() || this.isUndefined();
        },
        isPromise() {
            return Object.prototype.toString.call(val) === '[object Promise]';
        },
    };
}
